import { FunctionComponent, memo } from "react";
import { NumericValue } from "@edgetier/client-components";
import { SpinnerUntil } from "@edgetier/components";

import { useInteractionsCount } from "hooks-for/interactions/use-interactions-counts";

import AnomalySummaryValue from "../anomaly-summary-value";

import { IProps } from "./anomaly-interactions-count.types";
import "./anomaly-interactions-count.scss";

/**
 * Display the number of interactions affected by an anomaly.
 * @param props.anomalyId     Anomaly to search.
 * @param props.endDateTime   Closing date in anomaly range.
 * @param props.startDateTime Opening date in anomaly range.
 * @returns                   Number of affected interactions.
 */
const AnomalyInteractionsCount: FunctionComponent<IProps> = ({ anomalyId, endDateTime, startDateTime, title }) => {
    const { data: interactionsCount, isLoading } = useInteractionsCount({ anomalyId, endDateTime, startDateTime });
    return (
        <AnomalySummaryValue title={title}>
            <SpinnerUntil<number[]> data={interactionsCount} isReady={!isLoading}>
                {(value) => <NumericValue value={value} />}
            </SpinnerUntil>
        </AnomalySummaryValue>
    );
};

export default memo(AnomalyInteractionsCount);
